import { useQuery } from '@tanstack/react-query';

import { cashRegisterQueries, useRefundReasonsListQuery } from '@/queries';

type Params = {
  isEnabled: boolean;
  cashRegistersUrl: string;
  refundReasonsUrl: string;
  cashRegisterFilters?: Record<string, unknown>;
};

export const useRefundOptions = (params: Params) => {
  const { isEnabled, cashRegistersUrl, refundReasonsUrl, cashRegisterFilters } =
    params;

  const { data: cashRegistersData } = useQuery(
    cashRegisterQueries.accessibleOptions({
      url: cashRegistersUrl,
      isEnabled,
      filters: cashRegisterFilters,
    }),
  );
  const { data: refundReasonsData } = useRefundReasonsListQuery(
    isEnabled ? refundReasonsUrl : '',
  );

  const cashRegisterOptions = (cashRegistersData?.data ?? []).map(
    (register) => ({
      id: String(register.id),
      name: `${register.name} (${register.location_name})`,
    }),
  );

  const refundReasonOptions = (refundReasonsData?.data ?? [])
    .filter((reason) => !reason.archived_at)
    .map((reason) => ({ id: String(reason.id), name: reason.name }));

  return { cashRegisterOptions, refundReasonOptions };
};
